import { Outlet } from "react-router-dom";

const AdminRouteLayout = ({ children }) => {
  const content = children ?? <Outlet />;

  return content;
};

export default AdminRouteLayout;
